import React from 'react';
import { LayoutPublic } from "../components/LayoutPublic";

export function BaseAndConditions() {
  return (
    <LayoutPublic>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 pt-24">
        <div className="p-6 md:p-8 lg:p-10">
          <h1 className="text-3xl lg:text-4xl font-semibold text-gray-900 mb-8 text-left">
            BASES Y CONDICIONES - PROMOCIÓN "CELEBRAMOS 5 AÑOS"
          </h1>
        
          <div className="">
            <div className="prose prose-lg max-w-none">
              
              <div className="mb-8">
                <h2 className="text-2xl font-semibold text-brand-red mb-4">1. ORGANIZADOR</h2>
                <p className="text-gray-700 leading-relaxed">
                  TIERRA GUARANI INMOBILIARIA S.A. en adelante el ORGANIZADOR, con RUC N° 80113585-0, 
                  domicilio situado en la calle Del Maestro entre Nuestra Señora de la Asunción y 
                  Teófilo Lessing N°48, de la ciudad de San Lorenzo, CEL+595 0984-577.585, realizará 
                  la promoción denominada "CELEBRAMOS 5 AÑOS", en adelante la PROMOCIÓN.
                </p>
              </div>

              <div className="mb-8">
                <h2 className="text-2xl font-semibold text-brand-red mb-4">2. VIGENCIA</h2>
                <p className="text-gray-700 leading-relaxed">
                  La PROMOCIÓN tendrá vigencia desde el 02/07/2025 hasta el 31/01/2026, 
                  y será válida para todo el territorio nacional.
                </p>
              </div>

              <div className="mb-8">
                <h2 className="text-2xl font-semibold text-brand-red mb-4">3. PARTICIPANTES</h2>
                <p className="text-gray-700 leading-relaxed">
                  Podrán participar de la PROMOCIÓN todas las personas físicas que cumplan 
                  los requisitos establecidos en estas bases y condiciones.
                </p>
              </div>

              <div className="mb-8">
                <h2 className="text-2xl font-semibold text-brand-red mb-4">4. RESTRICCIONES DE PARTICIPACIÓN</h2>
                <p className="text-gray-700 mb-4">No podrán participar de la PROMOCIÓN, ni hacerse acreedores de los premios:</p>
                <ul className="list-disc pl-6 space-y-2 text-gray-700">
                  <li>Los menores de 18 años</li>
                  <li>Los prófugos de la justicia o con privación de libertad por mandato judicial</li>
                  <li>Los propietarios, accionistas, apoderados, directivos, gerentes, funcionarios o empleados del ORGANIZADOR, o sus familiares directos (padres, hijos, hermanos, cónyuges)</li>
                  <li>Directivos y Proveedores de las marcas aliadas</li>
                </ul>
              </div>

              <div className="mb-8">
                <h2 className="text-2xl font-semibold text-brand-red mb-4">5. SISTEMA DE PARTICIPACIÓN</h2>
                <p className="text-gray-700 mb-4">
                  Participan de la promoción todos las personas que realicen los siguientes pasos mencionados en la red social a través de Instagram:
                </p>
                <ul className="list-disc pl-6 space-y-2 text-gray-700">
                  <li>Seguir la cuenta @tginmobiliaria_</li>
                  <li>Dar Like al post de la publicación</li>
                  <li>Etiquetar a 2 personas (ambas deberán seguir la página mencionada)</li>
                </ul>
                <p className="text-gray-700 mt-4">
                  Se tendrá en cuenta todos ítems durante la vigencia de la PROMOCIÓN.
                </p>
              </div>

              <div className="mb-8">
                <h2 className="text-2xl font-semibold text-brand-red mb-4">6. PREMIOS</h2>
                <p className="text-gray-700 mb-4">
                  Durante la PROMOCIÓN será sorteado el siguiente premio:
                </p>
                <div className="bg-gray-50 p-4 rounded-lg">
                  <p className="text-gray-700">
                    <strong>Un inmueble</strong> situado en el Departamento de Cordillera del Distrito de Emboscada, 
                    lugar denominado Yeguarizo, Compañía Isla Alta, individualizado como Lote N°3, de la Manzana 26, 
                    con Cuenta Corriente Catastral N°19-0116-03, con una Superficie de Trescientos Sesenta metros cuadrados (360 m²).
                  </p>
                </div>
                <p className="text-gray-700 mt-4">
                  En caso que los premios deban transferirse por escritura pública (automóviles, motos, casas, terrenos, etc.), 
                  se debe especificar que los gastos de transferencia estarán a cargo del ORGANIZADOR, conforme al Art. 18° de la Ley 1016/97.
                </p>
              </div>

              <div className="mb-8">
                <h2 className="text-2xl font-semibold text-brand-red mb-4">7. SORTEO</h2>
                <p className="text-gray-700 mb-4">
                  El sorteo será realizado en fecha 31/01/2026 en el local ubicado en calle Del Maestro entre 
                  Nuestra Señora de la Asunción y Teófilo Lessing N°48, de la ciudad de San Lorenzo.
                </p>
                <ul className="list-disc pl-6 space-y-2 text-gray-700">
                  <li>
                    Como sistema de sorteo se empleará el uso de sorteo vía aplicación, el mismo será gravado 
                    y posteriormente se subirá a las redes sociales, Instagram y Facebook, a fin de la corroboración de los usuarios.
                  </li>
                  <li>
                    Durante el sorteo de cada premio además se seleccionará un segundo ganador que corresponderá 
                    al ganador suplente, quien será el acreedor del premio únicamente en caso que el ganador titular 
                    se encuentre inhabilitado, según las restricciones de participación de estas bases y condiciones.
                  </li>
                </ul>
              </div>

              <div className="mb-8">
                <h2 className="text-2xl font-semibold text-brand-red mb-4">8. EXCLUSIÓN</h2>
                <p className="text-gray-700 leading-relaxed">
                  En el caso en que el ORGANIZADOR constate que el potencial ganador se encuentra inhabilitado 
                  por hallarse dentro de las restricciones de participación establecidas en estas bases y condiciones, 
                  se procederá a la anulación del ganador seleccionado, dejando constancia del hecho mediante acta 
                  notarial donde se describirá en detalle el motivo. En este caso, el participante, ganador suplente, 
                  con el cupón suplente pasará a ser el acreedor del premio, lo cual se dejará constancia en la misma acta notarial.
                </p>
              </div>

              <div className="mb-8">
                <h2 className="text-2xl font-semibold text-brand-red mb-4">9. NOTIFICACIÓN</h2>
                <p className="text-gray-700 leading-relaxed">
                  Los ganadores serán notificados vía telefónica en el transcurso de las 48 horas posteriores al sorteo. 
                  Además, el listado de ganadores (nombre, apellido, y tres últimos dígitos del documento de identidad) 
                  será publicado en la página web del ORGANIZADOR y en sus redes sociales.
                </p>
              </div>

              <div className="mb-8">
                <h2 className="text-2xl font-semibold text-brand-red mb-4">10. RETIRO DE PREMIOS</h2>
                <p className="text-gray-700 leading-relaxed">
                  El ganador tendrá un plazo improrrogable de 60 días hábiles posteriores a la fecha del sorteo 
                  para retirar el premio, y a tal efecto deberá presentarse en el lugar indicado por el ORGANIZADOR 
                  con Cédula de Identidad.
                </p>
              </div>

              <div className="mb-8">
                <h2 className="text-2xl font-semibold text-brand-red mb-4">11. PREMIOS VACANTES</h2>
                <p className="text-gray-700 leading-relaxed">
                  Cumplido el plazo sin que se haya presentado el ganador, el valor del premio será destinado 
                  al financiamiento del FONARESS, conforme a lo establecido en la Ley 6703/20, y sus modificaciones.
                </p>
              </div>

              <div className="mb-8">
                <h2 className="text-2xl font-semibold text-brand-red mb-4">12. RESPONSABILIDAD</h2>
                <p className="text-gray-700 leading-relaxed">
                  El ORGANIZADOR no será responsable del uso o destino que el ganador otorgue a los premios recibidos.
                </p>
              </div>

              <div className="mb-8">
                <h2 className="text-2xl font-semibold text-brand-red mb-4">13. PUBLICIDAD</h2>
                <p className="text-gray-700 leading-relaxed">
                  El ganador, al momento de aceptar y retirar el premio, otorga de manera gratuita al ORGANIZADOR 
                  el derecho a publicitar su nombre e imagen, para la difusión en comerciales de televisión, radio, 
                  prensa escrita o redes sociales, por un plazo de 12 meses de finalizada la PROMOCIÓN. Esta cesión 
                  de derechos será otorgada al solo efecto de publicitar el resultado de la promoción de referencia, 
                  y no será utilizada para otros fines.
                </p>
              </div>

              <div className="mb-8">
                <h2 className="text-2xl font-semibold text-brand-red mb-4">14. PRIVACIDAD</h2>
                <p className="text-gray-700 leading-relaxed">
                  Los datos personales de los participantes que el ORGANIZADOR reciba o posea serán tratados 
                  de acuerdo a la legislación vigente en materia de protección de datos de carácter personal. 
                  El ORGANIZADOR se compromete a dar un tratamiento prudente y cuidadoso de los datos entregados 
                  por el PARTICIPANTE y almacenados al momento del registro de la PROMOCIÓN.
                </p>
              </div>

              <div className="mb-8">
                <h2 className="text-2xl font-semibold text-brand-red mb-4">15. MODIFICACIONES</h2>
                <p className="text-gray-700 leading-relaxed">
                  El ORGANIZADOR podrá, previa autorización de CONAJZAR, modificar, extender, ampliar, suspender 
                  o cancelar esta PROMOCIÓN cuando circunstancias imprevistas así lo justifiquen. En todos los casos, 
                  las modificaciones introducidas deberán ajustarse a la legislación vigente y no afectarán derechos adquiridos.
                </p>
              </div>

              <div className="mb-8">
                <h2 className="text-2xl font-semibold text-brand-red mb-4">16. REGLAMENTO DE LA PROMOCIÓN</h2>
                <p className="text-gray-700 leading-relaxed">
                  La participación en la promoción implica la aceptación de lo establecido en estas bases y condiciones, 
                  documento que estará a disposición de los participantes en el sitio web del organizador y en sus redes sociales. 
                  La eventual declaración de nulidad de una o más cláusulas de estas Bases y Condiciones, no afectará la validez 
                  de las demás cláusulas.
                </p>
              </div>

              <div className="mb-8">
                <h2 className="text-2xl font-semibold text-brand-red mb-4">17. CONDICIONES DE USO</h2>
                <p className="text-gray-700 leading-relaxed">
                  Además de cumplir con lo establecido en las presentes Bases y Condiciones, el PARTICIPANTE se compromete 
                  a cumplir con los requisitos y disposiciones establecidas en el reglamento de condiciones de uso de la aplicación 
                  o plataforma web que el ORGANIZADOR pondrá a disposición de los participantes durante la vigencia de la PROMOCIÓN.
                </p>
              </div>

              <div className="mb-8">
                <h2 className="text-2xl font-semibold text-brand-red mb-4">18. INTERPRETACIÓN</h2>
                <p className="text-gray-700 leading-relaxed">
                  Ante cualquier discrepancia o contradicción que pudiese existir entre las disposiciones establecidas 
                  en las presentes Bases y Condiciones y en los reglamentos de condiciones de uso mencionados en el artículo anterior, 
                  prevalecerá lo establecido en las presentes Bases y Condiciones.
                </p>
              </div>

              <div className="mb-8">
                <h2 className="text-2xl font-semibold text-brand-red mb-4">19. JURISDICCIÓN</h2>
                <p className="text-gray-700 leading-relaxed">
                  Toda situación que pudiera derivar en un conflicto entre el ORGANIZADOR y el PARTICIPANTE podrá ser resuelta, 
                  a pedido de las partes, por la CONAJZAR. Queda además expedita la vía jurisdiccional, en caso que los interesados 
                  así lo consideren para la mejor defensa de sus derechos, y a tal efecto, se establecen los tribunales ordinarios 
                  de la ciudad de SAN LORENZO.
                </p>
              </div>

              <div className="mt-12 p-6 bg-gray-50 rounded-lg">
                <p className="text-center text-gray-600 font-medium">
                  Para consultas sobre el sorteo, contactar a Tierra Guaraní Inmobiliaria al 0984 577 585
                </p>
              </div>

            </div>
          </div>
        </div>
      </div>
    </LayoutPublic>
  );
}